export default __webpack_public_path__ + "static/media/dessert-3.909f003f.jpg";